var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:[_vm.shouldAnimate, ''],attrs:{"fab":"","small":"","raised":"","text":""}},[_c('v-icon',{on:{"click":function($event){return _vm.toggleTheme()}}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }